import { fromNano } from '@ton/core'

export const calculateProfitability = (input: {
  estimatedPotentialReturnFor1Ton: string | bigint | null
}): number => {
  if (!input.estimatedPotentialReturnFor1Ton) {
    return 0
  }

  const returnPer1TonNano = BigInt(input.estimatedPotentialReturnFor1Ton)
  return Number(fromNano(returnPer1TonNano)) * 100
}
